import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import nlTranslation from './locales/nl/translation.json';
import { supportResources } from './locales/supportResources';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
        ...supportResources.en
      },
      nl: {
        translation: nlTranslation,
        ...supportResources.nl
      }
    },
    lng: 'en', // default language
    defaultNS: 'translation',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
